/** @jsx jsx */
import { jsx, ThemeProvider } from 'theme-ui';
import theme from './index';
import components from './components';
export const wrapRootElement = _ref => {
  let {
    element
  } = _ref;
  return jsx(ThemeProvider, {
    theme,
    components
  }, element);
};